import React from 'react';
import { useMatch } from 'react-router-dom';

const isLoggedIn = () => {
    return localStorage.getItem('token')
}

const SignUpModal = ({ isOpen, onClose }) => {
    const match = useMatch('/login');
    const isLoginPage = !!match; // converts to boolean
    if (!isOpen) return null;

    const handleProceed = () => {
        onClose(true); // Pass true to indicate they want to proceed
    };

    const handleCancel = () => {
        onClose(false); // Pass false to just close
    };

    const steps = [
        {
            number: 1,
            title: "Create an Account",
            description: isLoggedIn() || isLoginPage ? "It looks like you've already done this. Great job!" : "Use the navigation bar to go to the login page. Click on 'Sign Up' and make a new account."
        },
        {
            number: 2,
            title: "Go to the 'Submit' Page",
            description: "Using the navigation bar (top if you're on PC, in the side bar if you're on mobile), click on 'Submit'"
        },
        {
            number: 3,
            title: "Submit Your Property Review!",
            description: "In the submit page, enter the review about the place you stay at, or a place you've rented before and press submit once you're done. Remember, more reviews = more entries!"
        }
    ];

    return (
        <>
            <style>{`
                /* Modal Overlay */
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0.6);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1000;
                    padding: 1rem;
                    animation: fadeIn 0.3s ease-out;
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideIn {
                    from { 
                        opacity: 0;
                        transform: translateY(-20px) scale(0.95);
                    }
                    to { 
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }

                /* Modal Container */
                .modal-container {
                    background-color: #FFFFFF;
                    border-radius: 16px;
                    padding: 2.5rem 3rem;
                    width: 100%;
                    max-width: 600px;
                    max-height: calc(100vh - 2rem);
                    margin: auto;
                    -webkit-overflow-scrolling: touch;
                    overflow-y: auto;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
                    position: relative;
                    animation: slideIn 0.3s ease-out;
                    font-family: 'Lato', sans-serif;
                }

                /* Modal Header */
                .modal-header {
                    text-align: center;
                    margin-bottom: 2rem;
                    border-bottom: 2px solid #E2E8F0;
                    padding-bottom: 1.5rem;
                }

                .modal-title {
                    font-family: 'Merriweather', serif;
                    font-size: 1.875rem;
                    font-weight: 900;
                    color: #2C5282;
                    margin: 0 0 0.5rem 0;
                }

                .modal-subtitle {
                    color: #4A5568;
                    font-size: 1rem;
                    margin: 0;
                    font-weight: 400;
                }

                /* Close Button */
                .modal-close {
                    position: absolute;
                    top: 1.5rem;
                    right: 1.5rem;
                    background: none;
                    border: none;
                    font-size: 1.5rem;
                    color: #718096;
                    cursor: pointer;
                    width: 2.5rem;
                    height: 2.5rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    transition: all 0.2s ease;
                }

                .modal-close:hover {
                    background-color: #F7FAFC;
                    color: #2D3748;
                    transform: scale(1.1);
                }

                /* Steps Container */
                .steps-container {
                    display: flex;
                    flex-direction: column;
                    gap: 1.5rem;
                }

                /* Individual Step */
                .step-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 1rem;
                    padding: 1.25rem;
                    background-color: #F7FAFC;
                    border-radius: 12px;
                    border-left: 4px solid #DD6B20;
                    transition: all 0.2s ease;
                }

                .step-item:hover {
                    background-color: #EDF2F7;
                    transform: translateX(4px);
                }

                /* Step Number Circle */
                .step-number {
                    background: linear-gradient(135deg, #DD6B20, #ED8936);
                    color: white;
                    width: 2.5rem;
                    height: 2.5rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    font-size: 1.125rem;
                    flex-shrink: 0;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                }

                /* Step Content */
                .step-content {
                    flex: 1;
                }

                .step-title {
                    font-family: 'Merriweather', serif;
                    font-size: 1.25rem;
                    font-weight: 700;
                    color: #2C5282;
                    margin: 0 0 0.5rem 0;
                }

                .step-description {
                    color: #4A5568;
                    line-height: 1.6;
                    margin: 0;
                    font-size: 0.95rem;
                }

                /* Modal Footer */
                .modal-footer {
                    margin-top: 2rem;
                    padding-top: 1.5rem;
                    border-top: 1px solid #E2E8F0;
                    text-align: center;
                }

                .modal-button {
                    background: linear-gradient(135deg, #e77e2e, #e2a373ff);
                    color: white;
                    border: none;
                    padding: 0.875rem 2rem;
                    border-radius: 8px;
                    font-weight: 700;
                    font-size: 1rem;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    font-family: 'Lato', sans-serif;
                }

                .modal-button:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(44, 82, 130, 0.4);
                }

                /* Responsive Design */
                @media (max-width: 640px) {
                    .modal-overlay {
                        padding: 0.5rem;
                        align-items: flex-start;
                        padding-top: 2rem;
                    }

                    .modal-container {
                        padding: 1.5rem 1.25rem;
                        margin: 0;
                        max-height: calc(100vh - 4rem);
                        border-radius: 12px;
                        min-height: auto;
                    }
                    
                    .modal-title {
                        font-size: 1.5rem;
                    }
                    
                    .modal-subtitle {
                        font-size: 0.9rem;
                    }

                    .step-item {
                        padding: 1rem 0.75rem;
                        gap: 0.75rem;
                    }
                    
                    .step-number {
                        width: 2rem;
                        height: 2rem;
                        font-size: 1rem;
                    }
                    
                    .step-title {
                        font-size: 1.125rem;
                    }

                    .step-description {
                        font-size: 0.9rem;
                    }

                    .modal-button {
                        padding: 0.75rem 1.5rem;
                        font-size: 0.95rem;
                        width: 100%;
                    }

                    .modal-header {
                        margin-bottom: 1.5rem;
                        padding-bottom: 1rem;
                    }

                    .steps-container {
                        gap: 1rem;
                    }

                    .modal-footer {
                        margin-top: 1.5rem;
                        padding-top: 1rem;
                    }
                }

                @media (max-height: 600px) {
                    .modal-overlay {
                        align-items: flex-start;
                        padding-top: 1rem;
                        overflow-y: auto;
                        -webkit-overflow-scrolling: touch;
                    }

                    .modal-container {
                        max-height: calc(100vh - 2rem);
                    }

                    .modal-header {
                        margin-bottom: 1rem;
                        padding-bottom: 0.75rem;
                    }

                    .steps-container {
                        gap: 0.75rem;
                    }

                    .step-item {
                        padding: 0.75rem;
                    }
                }
            `}</style>

            <div className="modal-overlay" onClick={handleCancel}>
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <button className="modal-close" onClick={handleCancel} aria-label="Close modal">
                        ×
                    </button>
                    
                    <div className="modal-header">
                        <h2 className="modal-title">Steps for Giveaway</h2>
                        <p className="modal-subtitle">Welcome to RentRadar! Please follow the below steps to qualify for the amazon gift card giveaway.</p>
                    </div>

                    <div className="steps-container">
                        {steps.map((step) => (
                            <div key={step.number} className="step-item">
                                <div className="step-number">
                                    {step.number}
                                </div>
                                <div className="step-content">
                                    <h3 className="step-title">{step.title}</h3>
                                    <p className="step-description">{step.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="modal-footer">
                        <button className="modal-button" onClick={handleProceed}>
                            Got it, let's start!
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SignUpModal;